import fetchWithCSRF from "@core/scripts/helper/fetch-with-csrf";

function get(url, paramString, errorMessage) {
    return fetchWithCSRF(`${url}${paramString}`)
        .then(toJsonOrThrow(new Error(errorMessage)));
}

function toJsonOrThrow(error) {
    return (response) => {
        if(response.ok) {
            return response.json();
        }
        throw error;
    };
}

export default {
    get
}